const pageOutRouter = [
  {
    path: '/mall/index/:id',
    name: '商城首页',
    component: function (resolve) {
      require(['@/page-out/mall/index'],resolve)
    },

  },{
    path: '/mall/rebate-rule',
    name: '返利规则',
    component: function (resolve) {
      require(['@/page-out/mall/rebate-rule'],resolve)
    }
  },{
    path: '/mall/income-rule',
    name: '收入提现',
    component: function (resolve) {
      require(['@/page-out/mall/income-rule'],resolve)
    }
  },{
    path: '/mall/sy-info/:id',
    name: '追溯信息',
    component: function (resolve) {
      require(['@/page-out/mall/sy-info'],resolve)
    }
  },{
    path: '/mall/view/:id/:userid',    //:    /mall/view/4282/12200/1
    name: '长文章',
    component: function (resolve) {
      require(['@/page-out/mall/view'],resolve)
    }
  }
]
export default pageOutRouter



// WEBPACK FOOTER //
// ./src/router/page-out-router.js